export const MIN_PHONE_LENGTH = 7;
export const CODE_LENGTH = 4;

export function validateEmail(value) {
    if (value.length > 180) {
        return i18next.t('validate.return.validateEmail.longEmail');
    }
    if (value.length === 0) {
        return i18next.t('validate.return.validateEmail.required');
    }

    return null;
}

export function validateFormatEmail(value) {
    const re = /\S+@\S+\.\S+/;
    if (!re.test(value)) {
        return i18next.t('validate.return.validateFormatEmail.invalidFormat');
    }
    return null;
}

export function validateName(value) {
    if (value.trim().length > 50) {
        return i18next.t('validate.return.validateName.longName');
    }
    if (value.trim().length === 0) {
        return i18next.t('validate.return.validateName.required');
    }

    return null;
}

export function validatePassword(value) {
    const re = /^(?=.*[0-9])(?=.*[a-zа-яёäöüA-ZA-ЯЁÄÖÜß])(?=.*[a-zA-Z]).{5,72}$/;

    if (value.length === 0) {
        return i18next.t('validate.return.validatePassword.required');
    }
    if (value.length > 72) {
        return i18next.t('validate.return.validatePassword.longPassword');
    }
    if (!re.test(value)) {
        return ' ';
    }

    return null;
}

export function validatePhone(e) {
    const { value } = e.target;

    if (value.length === 0) {
        return i18next.t('validate.return.validatePhone.required');
    }
    if (value.length <= MIN_PHONE_LENGTH) {
        return i18next.t('validate.return.validatePhone.invalid');
    }

    return null;
}

export function isValidPhoneNumberFormat(e) {
    const re = /^\+?[0-9]*$/;

    return re.test(e.target.value);
}

export function isValidCodeFormat(code) {
    const re = /^[0-9]{0,4}$/;

    return re.test(code);
}

export function validateCode(code) {
    if (code.length === 0) {
        return i18next.t('validate.return.validateCode.required');
    }

    if (code.length !== CODE_LENGTH) {
        return i18next.t('validate.return.validateCode.invalid');
    }

    return null;
}
